/*
 * Silarius Kit Builder on silarius.com (sections/silarius-kit-builder.liquid). Silarius products only.
 * Switch rule (Ben, Oct 3 2026): ONE of SIL-B16M3POE1G300 / SIL-B24M3POE1G400 / SIL-B48M3POE1G500,
 * sized for the cameras + 1 port for the router + 1 port for the NVR when there is one:
 * 16-port up to 14 cameras + NVR (15 without), 24-port up to 22 + NVR (23 without),
 * 48-port up to 46 + NVR (47 without). Bigger projects chain 48-port switches.
 * Hard drives (Ben, Oct 21 2026): the NVR is always the base "No HDD" product (cfg.recorders[].drives["0"])
 * plus a hidden drive-option product (silarius-nvr-hard-drive-option-<N>tb) as its own cart line,
 * exactly like the product page. The old "<N>TB HDD" NVR products are no longer used.
 * One-bay NVRs: 2/4/8/10/12/18/22/24 TB. Two-bay (tag nvr-hdd-bays-2): also 16, 36, 48 TB (two identical drives).
 */
(function () {
  var root = document.querySelector('[data-sil-kit]');
  if (!root) return;
  var cfg;
  try { cfg = JSON.parse(root.querySelector('[data-sil-kit-config]').textContent); } catch (e) { return; }

  var GB_PER_DAY = {5: 32.4, 8: 64.8}; // continuous H.265 per camera
  var SIZES1 = [2, 4, 8, 10, 12, 18, 22, 24];
  var SIZES2 = [2, 4, 8, 10, 12, 16, 18, 22, 24, 36, 48];
  var TWO = {16: 8, 36: 18, 48: 24};
  var DRV = {};
  SIZES2.forEach(function (s) { DRV[s] = 'silarius-nvr-hard-drive-option-' + s + 'tb'; });
  var STYLE_WHY = {
    dome: 'Silarius X dome: ceilings, entrances and hallways',
    bullet: 'Silarius X bullet: weatherproof, night vision, walls and driveways',
    turret: 'Silarius X turret: easy to aim, no IR glare, inside or out',
  };
  var TIER_NAME = {mobile: 'Mobile (720p)', pro: 'Pro (1080p)', uhd: '4K'};
  var state = {dome: 2, bullet: 2, turret: 0, res: 5, rec: 'nvr', days: 30, tier: 'pro', optSwitch: false, removed: {}};
  // Items the shopper removed from the kit (Ben, Oct 3 2026), by kind: nvr, hdd, switch, plugs, cloud.
  var KIND_NAME = {nvr: 'NVR', hdd: 'Hard drive', 'switch': 'PoE switch', plugs: 'Cat6 plugs', cloud: 'Silarius Cloud plan'};
  var P = {}; // handle -> product JSON
  var kit = null;
  var result = root.querySelector('[data-sil-kit-result]');

  function money(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]; });
  }
  function avail(p) { return p && p.available && p.variants && p.variants[0]; }
  function img(p) {
    var u = p && (p.featured_image || (p.images && p.images[0]));
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }
  function hddLabel(tb) { return tb + 'TB (' + (TWO[tb] ? '2 × ' + TWO[tb] : '1 × ' + tb) + 'TB)'; }
  function titleWithDrive(title, sku, tb) {
    var t = sku ? title.split(sku).join(sku + tb) : title;
    return /\bno\s+hdd\b/i.test(t) ? t.replace(/\bno\s+hdd\b/i, tb + 'TB HDD') : t + ', ' + tb + 'TB HDD';
  }

  function switchPlan(cameras, withNvr) {
    var plan = [];
    var left = cameras;
    var reserved = 1 + (withNvr ? 1 : 0);
    while (left > 0 && plan.length < 10) {
      var fits = null;
      for (var i = 0; i < cfg.switches.length; i++) {
        if (cfg.switches[i].ports >= left + reserved) { fits = cfg.switches[i]; break; }
      }
      if (fits) { plan.push({ports: fits.ports, handle: fits.handle, cameras: left}); break; }
      var big = cfg.switches[cfg.switches.length - 1];
      var take = big.ports - reserved - 1;
      plan.push({ports: big.ports, handle: big.handle, cameras: take});
      left -= take;
      reserved = 1;
    }
    return plan;
  }

  function cloudVariant(tierKey, days) {
    var p = P[cfg.cloud[tierKey]];
    if (!p || !p.variants) return null;
    var best = null;
    p.variants.forEach(function (v) {
      var a = v.selling_plan_allocations && v.selling_plan_allocations[0];
      if (!v.available || !a || /AI/.test(v.option2 || '') || /hour/i.test(v.option1 || '')) return;
      var d = parseInt(v.option1, 10);
      var score = d === days ? -1 : (d >= days ? d - days : 1000 + days - d);
      if (!best || score < best.score) best = {v: v, a: a, days: d, score: score};
    });
    return best;
  }

  function build() {
    var n = state.dome + state.bullet + state.turret;
    var items = [];
    var notes = [];
    var monthly = 0;
    var optional = null;
    var removed = [];
    function add(p, qty, why, extra) {
      if (!avail(p) || qty <= 0) return false;
      var kind = extra && extra.kind;
      if (kind && state.removed[kind]) {
        if (removed.indexOf(kind) < 0) removed.push(kind);
        return true;
      }
      var v = (extra && extra.variant) || p.variants[0];
      items.push({p: p, v: v, qty: qty, why: why, kind: kind, plan: extra && extra.plan, unit: extra && extra.unit != null ? extra.unit : v.price, monthly: extra && extra.monthly,
        title: extra && extra.title, url: extra && extra.url, props: extra && extra.props});
      return true;
    }
    if (!n) return {n: 0, items: [], notes: ['Add at least one camera.'], hardware: 0, monthly: 0, optional: null, removed: []};

    ['dome', 'bullet', 'turret'].forEach(function (s) {
      if (!state[s]) return;
      var p = P[cfg.cameras[s][state.res]];
      if (!add(p, state[s], STYLE_WHY[s] + ', ' + (state.res === 8 ? '4K' : '5MP'), {kind: 'cam-' + s})) notes.push('A ' + s + ' camera is out of stock right now. Email us and we will suggest an alternative.');
    });

    var withNvr = state.rec === 'nvr' || state.rec === 'both';
    var nvrPoe = 0;
    var switches = withNvr ? null : switchPlan(n, false);
    if (withNvr) {
      var needTB = (n * GB_PER_DAY[state.res] * state.days) / 1000;
      var best = null;
      cfg.recorders.forEach(function (r) {
        if (r.channels < n) return;
        var rec = P[r.drives['0']];
        if (!avail(rec)) return;
        var sizes = ((rec.tags || []).indexOf('nvr-hdd-bays-2') > -1 ? SIZES2 : SIZES1).filter(function (s) { return avail(P[DRV[s]]); });
        if (!sizes.length) return;
        var drive = sizes[sizes.length - 1];
        for (var i = 0; i < sizes.length; i++) if (sizes[i] >= needTB) { drive = sizes[i]; break; }
        var sw = state.rec === 'nvr' && r.poe >= n ? [] : switchPlan(n, true);
        var ok = sw.every(function (s) { return avail(P[s.handle]); });
        if (!ok) return;
        var full = drive >= needTB;
        var cover = Math.min(drive, needTB); // most storage first (up to what is needed), then cheapest
        var cost = rec.variants[0].price + P[DRV[drive]].variants[0].price + sw.reduce(function (t, s) { return t + P[s.handle].variants[0].price; }, 0);
        if (!best || cover > best.cover || (cover === best.cover && cost < best.cost)) best = {r: r, rec: rec, sw: sw, cost: cost, drive: drive, full: full, cover: cover};
      });
      if (best) {
        var drive = best.drive;
        var covered = Math.floor((drive * 1000) / (n * GB_PER_DAY[state.res]));
        var rv = best.rec.variants[0];
        var sku = rv.sku || '';
        var withHdd = !state.removed.hdd;
        var m = withHdd ? sku + drive : sku;
        var base = best.r.channels + '-channel Silarius NVR' + (best.r.poe ? ' with ' + best.r.poe + ' built-in PoE ports' : '');
        add(best.rec, 1, withHdd ? base + ', model ' + m + ' with the ' + drive + ' TB hard drive below' : base + ', no hard drive', withHdd ? {
          kind: 'nvr', title: titleWithDrive(best.rec.title, sku, drive), url: best.rec.url + '?hdd=' + drive,
          props: {'Model': m, 'Hard drive': hddLabel(drive), '_hdd_tb': String(drive)}
        } : {kind: 'nvr'});
        if (!state.removed.nvr) {
          add(P[DRV[drive]], 1, (TWO[drive] ? '2 × ' + TWO[drive] + ' TB drives, both the same model' : 'One ' + drive + ' TB drive') + ' for about ' + Math.min(covered, 999) + ' days of continuous recording', {
            kind: 'hdd', title: drive + 'TB hard drive for ' + sku + drive, url: best.rec.url + '?hdd=' + drive,
            props: {'For NVR': sku + drive, '_hdd_nvr': String(rv.id)}
          });
        }
        nvrPoe = best.r.poe;
        switches = best.sw;
        if (!best.full) notes.push(state.days + ' days of continuous recording needs about ' + Math.ceil(needTB) + ' TB. The ' + drive + ' TB option keeps about ' + covered + ' days; recording on motion keeps much longer. Email us and we will size the storage with you.');
      } else {
        notes.push('More than 36 cameras on site: email us and we will size the recorders with you.');
        switches = switchPlan(n, true);
      }
    }
    (switches || []).forEach(function (s, k) {
      var why = s.ports + '-port PoE+ switch: powers and connects ' + s.cameras + ' camera' + (s.cameras === 1 ? '' : 's') + (withNvr && k === 0 ? ', the NVR' : '') + ' and the internet line from your router';
      var p = P[s.handle];
      var same = items.filter(function (x) { return x.p === p; })[0];
      if (same) same.qty += 1;
      else if (!add(p, 1, why, {kind: 'switch'})) notes.push('The ' + s.ports + '-port switch is out of stock right now. Email us and we will complete the kit.');
    });
    // Ben (Oct 3 2026): the PoE NVR powers every camera, so the switch is optional ("Optional, NVR already has PoE").
    if (withNvr && !switches.length && nvrPoe >= n) {
      var os = switchPlan(n, true)[0];
      var op = os && P[os.handle];
      if (avail(op)) {
        optional = {p: op, v: op.variants[0], ports: os.ports};
        if (state.optSwitch) add(op, 1, 'Optional, NVR already has PoE: ' + os.ports + '-port PoE+ switch for spare ports', {kind: 'optswitch'});
      }
    }
    add(P[cfg.plugs], Math.max(1, Math.ceil((n * 2) / 100)), 'Cat6 plugs (100 per pack) for both ends of every cable run', {kind: 'plugs'});

    if (state.rec === 'cloud' || state.rec === 'both') {
      var c = cloudVariant(state.tier, state.days);
      if (c) {
        if (!state.removed.cloud) monthly = c.a.price * n;
        add(P[cfg.cloud[state.tier]], n, 'Silarius Cloud ' + TIER_NAME[state.tier] + ', keeps ' + c.days + ' days of video, one plan per camera. Silarius X cameras connect straight to the cloud, no Gateway needed.', {variant: c.v, plan: c.a.selling_plan_id, unit: c.a.price, monthly: true, kind: 'cloud'});
        if (c.days !== state.days) notes.push('Silarius Cloud ' + TIER_NAME[state.tier] + ' keeps ' + c.days + ' days, the closest to what you chose.');
      } else {
        notes.push('Silarius Cloud ' + TIER_NAME[state.tier] + ' is not available right now. Pick another quality.');
      }
      if (!state.removed.cloud) notes.push('Billed monthly, no commitment: cancel with 1 month notice. Switch to yearly billing in your cart and save 10%.');
    }
    var hardware = items.reduce(function (t, x) { return t + (x.monthly ? 0 : x.unit * x.qty); }, 0);
    return {n: n, items: items, notes: notes, hardware: hardware, monthly: monthly, optional: optional, removed: removed};
  }

  function syncForm() {
    ['dome', 'bullet', 'turret'].forEach(function (s) {
      var el = root.querySelector('[data-count="' + s + '"]');
      if (el && String(el.value) !== String(state[s])) el.value = state[s];
    });
    root.querySelectorAll('[data-opt]').forEach(function (b) {
      var on = String(state[b.getAttribute('data-opt')]) === b.getAttribute('data-v');
      b.classList.toggle('is-active', on);
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    root.querySelector('[data-sil-kit-cloudq]').hidden = !(state.rec === 'cloud' || state.rec === 'both');
  }

  function render() {
    syncForm();
    kit = build();
    var h = '<h2>Your Silarius kit</h2><p class="SilKit__Sub">' + kit.n + ' camera' + (kit.n === 1 ? '' : 's') + ', ' + (state.res === 8 ? '4K' : '5MP') + ', ' +
      {nvr: 'recorded on site', cloud: 'recorded in Silarius Cloud', both: 'recorded on site and in Silarius Cloud'}[state.rec] + ', ' + state.days + ' days</p>';
    if (kit.items.length) {
      h += '<ul class="SilKit__Items">';
      kit.items.forEach(function (x) {
        h += '<li class="SilKit__Item"><img src="' + esc(img(x.p)) + '" alt="" width="56" height="56" loading="lazy"><div><a href="' + esc(x.url || x.p.url) + '" target="_blank" rel="noopener">' + esc(x.title || x.p.title) + '</a><span class="SilKit__Why">' + esc(x.why) + '</span></div>' +
          '<div class="SilKit__Price">' + x.qty + ' &times; ' + money(x.unit) + (x.monthly ? '/mo' : '') + '<small>' + money(x.unit * x.qty) + (x.monthly ? ' per month' : '') + '</small>' +
          (x.kind ? '<button type="button" data-sil-kit-remove="' + esc(x.kind) + '" style="margin-top:4px;padding:0;border:0;background:none;color:#b42318;font-size:12px;text-decoration:underline;cursor:pointer">Remove</button>' : '') + '</div></li>';
      });
      if (kit.optional && !state.optSwitch) {
        var o = kit.optional;
        h += '<li class="SilKit__Item SilKit__Item--opt"><img src="' + esc(img(o.p)) + '" alt="" width="56" height="56" loading="lazy"><div><span class="SilKit__OptTag">Optional, NVR already has PoE</span><a href="' + esc(o.p.url) + '" target="_blank" rel="noopener">' + esc(o.p.title) + '</a><span class="SilKit__Why">Not included in the total. Every camera plugs into the NVR; add the switch only if you want spare ports for more cameras later.</span></div>' +
          '<div class="SilKit__Price">' + money(o.v.price) + '<small><button type="button" class="SilKit__OptAdd" data-sil-kit-opt="1">Add to kit</button></small></div></li>';
      }
      h += '</ul>';
      if (kit.removed.length) {
        h += '<p style="margin:10px 0 0;font-size:12px;color:#5b6773">Removed from your kit: ' + kit.removed.map(function (k) {
          return esc(KIND_NAME[k] || k) + ' <button type="button" data-sil-kit-restore="' + esc(k) + '" style="padding:0;border:0;background:none;color:#1e6fb8;font-size:12px;text-decoration:underline;cursor:pointer">Add back</button>';
        }).join(' &middot; ') + '</p>';
      }
      h += '<div class="SilKit__Totals"><div><span>Hardware (one-time)</span><strong>' + money(kit.hardware) + '</strong></div>';
      if (kit.monthly) h += '<div><span>Silarius Cloud</span><span>' + money(kit.monthly) + ' per month</span></div>';
      h += '<div><span>Shipping</span><span>Free</span></div></div>';
    }
    if (kit.notes.length) h += '<div class="SilKit__Notes">' + kit.notes.map(function (t) { return '<p>' + esc(t) + '</p>'; }).join('') + '</div>';
    if (kit.items.length) h += '<button type="button" class="SilKit__Add" data-sil-kit-add>Add kit to cart</button><p class="SilKit__Fine">Every part is a Silarius product with the Silarius 3-year warranty. You can change quantities in your cart.</p>';
    result.innerHTML = h;
  }

  root.addEventListener('click', function (e) {
    var step = e.target.closest('[data-step]');
    if (step) {
      var k = step.getAttribute('data-step');
      state[k] = Math.max(0, Math.min(100, state[k] + parseInt(step.getAttribute('data-d'), 10)));
      render();
      return;
    }
    var opt = e.target.closest('[data-opt]');
    if (opt) {
      var key = opt.getAttribute('data-opt');
      var v = opt.getAttribute('data-v');
      state[key] = key === 'res' || key === 'days' ? parseInt(v, 10) : v;
      if (key === 'rec') state.optSwitch = false;
      render();
      return;
    }
    var rm = e.target.closest('[data-sil-kit-remove]');
    if (rm) {
      var kind = rm.getAttribute('data-sil-kit-remove');
      if (kind.indexOf('cam-') === 0) state[kind.slice(4)] = 0; // a camera line: set that style to 0
      else if (kind === 'optswitch') state.optSwitch = false;
      else state.removed[kind] = true;
      render();
      return;
    }
    var rs = e.target.closest('[data-sil-kit-restore]');
    if (rs) {
      delete state.removed[rs.getAttribute('data-sil-kit-restore')];
      render();
      return;
    }
    var optBtn = e.target.closest('[data-sil-kit-opt]');
    if (optBtn) {
      state.optSwitch = true;
      render();
      return;
    }
    var addBtn = e.target.closest('[data-sil-kit-add]');
    if (!addBtn || !kit || !kit.items.length) return;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';
    var lines = kit.items.map(function (x) {
      var l = {id: x.v.id, quantity: x.qty};
      if (x.plan) l.selling_plan = x.plan;
      if (x.props) l.properties = x.props;
      return l;
    });
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
      body: JSON.stringify({items: lines}),
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Could not add the kit to your cart');
        window.location.href = '/cart';
      });
    }).catch(function (err) {
      addBtn.disabled = false;
      addBtn.textContent = 'Add kit to cart';
      var m = document.createElement('p');
      m.className = 'SilKit__Error';
      m.textContent = err.message;
      addBtn.insertAdjacentElement('afterend', m);
    });
  });
  root.addEventListener('input', function (e) {
    var k = e.target.getAttribute && e.target.getAttribute('data-count');
    if (!k) return;
    var v = parseInt(e.target.value, 10);
    state[k] = isNaN(v) ? 0 : Math.max(0, Math.min(100, v));
    render();
  });

  var handles = [cfg.plugs];
  Object.keys(cfg.cameras).forEach(function (s) { handles.push(cfg.cameras[s]['5'], cfg.cameras[s]['8']); });
  cfg.recorders.forEach(function (r) { if (r.drives && r.drives['0']) handles.push(r.drives['0']); });
  SIZES2.forEach(function (s) { handles.push(DRV[s]); });
  cfg.switches.forEach(function (s) { handles.push(s.handle); });
  Object.keys(cfg.cloud).forEach(function (k) { handles.push(cfg.cloud[k]); });
  Promise.all(handles.map(function (h) {
    return fetch('/products/' + h + '.js', {credentials: 'same-origin'})
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p && p.vendor === 'Silarius') P[h] = p; })
      .catch(function () {});
  })).then(render);
})();